<div class="block-full-width"
    [ngClass]="{'remove-padding':removePadding,'no-empty-state-block': !isEmpty, 'empty-state-block':isEmpty , 'block-full-width-secondary': secondaryColor, 'no-margin-bottom': removeMargin, 'block-full-width-secondary-v2': secondaryBlockBackGroundV2}">
    <ng-content></ng-content>
</div>
